import styled from "styled-components";

export const LinkTextContainer = styled.a`
  text-decoration: none;
  color: ${(props) => (props.color ? props.color : "white")};
`;
